const localStorage = window.localStorage;
const PREFIX = 'modelstore.';
export default {
    /**
     * get 获取 localStorage 中某一项缓存
     *
     * @description 如果没有输入 key 值, 则返回全部 ls
     * @param  {string} key 缓存的 key
     *
     * @return {string} 缓存中 key 对应的具体值
     */
    get (key) {
        if (!key) {
            return localStorage;
        }
        key = PREFIX + key;
        return localStorage.getItem(key);
    },

    /**
     * 获取存储在localStorage中的，以字符串形式存储的json
     * @param {String} key - localStorage中的key
     *
     * @returns {Object} 存储的对象
     */
    getJson (key) {
        if (!key) {
            return localStorage;
        }
        key = PREFIX + key;
        try {
            return JSON.parse(localStorage.getItem(key) || '{}');
        } catch (e) {
            return {};
        }
    },

    /**
     * set 在 localStorage 中添加
     *
     * @description 如果没有输入 key 值, 则不做任何操作, 直接返回
     * @param  {string}  key 缓存的 key
     * @param  {string}  val 缓存的 key 对应的具体值
     *
     * @return {Boolean} 添加成功或失败的结果
     */
    set (key, val) {
        if (!key || !val) {
            return;
        }

        key = PREFIX + key;
        // set
        localStorage.setItem(key, val);
        if (this.get(key) === val) {
            return true;
        }
        return false;
    },

    /**
     * 在localStorage中添加能被JSON.stringify解析的类型
     *
     * @param {string} key - 存储的key
     * @param {*} val - 要存储的值
     *
     * @returns {Boolean} 成功与否
     */
    setJson (key, val) {
        if (!key || !val) {
            return;
        }

        key = PREFIX + key;
        const str = JSON.stringify(val);
        localStorage.setItem(key, str);
        if (this.get(key) === str) {
            return true;
        }
        return false;
    },

    /**
     * remove 移除 localStorage 中的某一项
     *
     * @description 如果没有输入 key 值, 则移除全部缓存
     * @param {string}  key 缓存的 key
     *
     * @return {Boolean} 移除成功或失败的结果
     */
    remove (key) {
        if (!key) {
            return this.clear();
        }

        key = PREFIX + key;
        // remove
        localStorage.removeItem(key);
        if (!this.get(key)) {
            return true;
        }
        return false;
    },

    /**
     * clear 清空本地关键字是 'sd.' 开头的缓存
     *
     * @description 如果有某一项清除失败, 则退出直接返回 false, 只有所有都清除成功才会返回 true
     *
     * @return {Boolean} 清空成功或失败的结果
     */
    clear () {
        for (let key of Object.keys(localStorage)) {
            if (key.startsWith('sd.')) {
                let result = Reflect.deleteProperty(localStorage, key);
                if (!result) {
                    return false;
                }
            }
        }
        // 默认删除成功, 如果有删除失败的情况提前退出
        return true;
    }
};